<template>
  <div class="row">
    <div class="col-10 col-sm-11">
      <h1 class="card-title" v-if="ticket['ticket_id'] !==0">Ticket #{{ticket['ticket_id']}}</h1>
      <h1 class="card-title" v-else>New ticket</h1>
    </div>
    <div class="col-2 col-sm-1">
      <base-button v-if="!ticket['is_delete']" type="danger" :disabled="!isAuthor || ticket['ticket_id'] == 0" size="sm" icon style="margin-left: -6px" @click="update('Delete')">
        <i class="tim-icons icon-trash-simple"></i>
      </base-button>
      <base-button v-else type="info" size="sm" icon :disabled="!isAuthor || ticket['ticket_id'] == 0" style="margin-left: -6px" @click="update('Restore')">
        <i class="tim-icons icon-refresh-01"></i>
      </base-button>
    </div>
  </div>
</template>

<script>
    export default {
      name: "TicketHead",
      props :['ticket' , 'isAuthor'],
      methods:{
        update(command){
          const data = {};
          let action = "";
          data['ticket_id'] = this.ticket['ticket_id'];
          if (command === "Delete"){
            action = "deleted";
            data['is_delete'] = "1";
            this.ticket['is_delete'] = true;
          }
          if (command === "Restore"){
            action = "restored";
            data['is_delete'] = "0";
            this.ticket['is_delete'] = false;
          }
          this.$emit("update", data, action);
        },
      },
    }
</script>

<style scoped>

</style>
